class ThumbnailService {

    constructor() {
        this.files = [];
        this.count = 5;
    }

    setFiles(files) {
        this.files = files || [];
    }

    getAround(index) {
        if (!this.files.length) {
            return [];
        }

        let start = index - Math.floor(this.count / 2);
        if (start < 0) {
            start = 0;
        }

        if (start + this.count > this.files.length) {
            start = this.files.length - this.count;
        }

        if (start < 0) {
            start = 0;
        }

        return this.files
            .slice(start, start + this.count)
            .map((item, i) => ({
                ...item,
                index: start + i
            }));
    }

    setCount(count) {
        this.count = count;
    }
}
export default new ThumbnailService();